import Vue from 'vue'
import VueRouter from 'vue-router'
import VueScrollTo from 'vue-scrollto'
import Home from '@/pages/home/home'
import AboutUs from '@/pages/about-us/about-us'
// import GettingStarted from '@/pages/getting-started/getting-started'
import Treatments from '@/pages/treatments/treatments'
// import WhyChooseUs from '@/pages/why-choose-us/why-choose-us'
import ContactUs from '@/pages/contact-us/contact-us'
import ThankYou from '@/pages/thank-you/thank-you'
import Accessibility from '@/pages/accessibility/accessibility'
// import PageNotFound from '@/pages/404/404'

Vue.use(VueRouter)

const scrollBehavior = function (to, from) {
  if (to.hash) {
    window.scrollTo(0, 0)
    VueScrollTo.scrollTo(to.hash, { offset: -140, duration: 1500, easing: 'ease-in' })
  } else {
    return { x: 0, y: 0 }
  }
}

const router = new VueRouter({
  mode: 'history',
  scrollBehavior,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      navigation: true,
      subnavigation: false
      // children: [
      //   {
      //     path: '/#contact-us',
      //     name: 'contact us',
      //     component: Home,
      //     navigation: false
      //   }
      // ]
    },
    // {
    //   path: '/why-choose-us',
    //   name: 'why choose us',
    //   component: WhyChooseUs,
    //   navigation: true,
    //   subnavigation: false
    // },
    // {
    //   path: '/getting-started',
    //   name: 'getting started',
    //   component: GettingStarted,
    //   navigation: true,
    //   subnavigation: true,
    //   children: [
    //     {
    //       path: '/getting-started#forms',
    //       name: 'patient forms',
    //       component: GettingStarted,
    //       navigation: false
    //     }
    //   ]
    // },
    {
      path: '/about-us',
      name: 'about us',
      component: AboutUs,
      navigation: true,
      subnavigation: false
    },
    {
      path: '/treatments',
      name: 'treatments',
      component: Treatments,
      navigation: true,
      subnavigation: false,
      children: [
        {
          path: '/treatments#smilegallery',
          name: 'smile gallery',
          component: Treatments,
          navigation: false
        }
      ]
    },
    {
      path: '/contact-us',
      name: 'contact us',
      component: ContactUs,
      navigation: false,
      subnavigation: false
    },
    {
      path: '/thank-you',
      name: 'thank-you',
      component: ThankYou,
      navigation: false,
      subnavigation: false
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      component: Accessibility,
      navigation: false,
      subnavigation: false
    },
    {
      path: '/*',
      name: 'redirect',
      component: Home,
      navigation: false,
      subnavigation: false
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js